import React from "react";
import ContactForm from './contactform';

export const Contact = (props) => {

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col">
            <div className="row">
              <div className="section-title">
                <h2>Remplissez pour commencer 👇 </h2>
                <p>
                  Bénéficiez d'un accompagnement sur mesure
                  jusqu'à l'obtention des documents.
                </p>
              </div>

            </div>
          </div>
          <div className="col">
          <ContactForm />
          </div>
          <div className="col col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact direct pour un service ultra-rapide ⚡ </h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
